module.exports = __webpack_public_path__ + "img/home-banner.5aeb235e.jpg";